import type { TextPathPreset } from '../types';

export const TEXT_PATH_PRESETS: TextPathPreset[] = [
  {
    id: 'arc-gentle',
    name: 'Gentle Arc',
    icon: '\u2312',
    pathData: 'M 0 60 Q 150 -10 300 60',
    category: 'arc',
  },
  {
    id: 'arc-steep',
    name: 'Steep Arc',
    icon: '\u2313',
    pathData: 'M 0 100 Q 150 -50 300 100',
    category: 'arc',
  },
  {
    id: 'arc-inverted',
    name: 'Inverted Arc',
    icon: '\u2314',
    pathData: 'M 0 0 Q 150 110 300 0',
    category: 'arc',
  },
  {
    id: 'arc-slight',
    name: 'Slight Arc',
    icon: '\u2040',
    pathData: 'M 0 30 Q 150 0 300 30',
    category: 'arc',
  },
  {
    id: 'wave-single',
    name: 'Single Wave',
    icon: '\u301C',
    pathData: 'M 0 50 C 100 0 200 100 300 50',
    category: 'wave',
  },
  {
    id: 'wave-double',
    name: 'Double Wave',
    icon: '\u2248',
    pathData: 'M 0 50 C 60 0 120 100 180 50 C 240 0 300 100 360 50',
    category: 'wave',
  },
  {
    id: 'wave-gentle',
    name: 'Gentle Wave',
    icon: '\u223F',
    pathData: 'M 0 40 C 75 20 150 60 225 40 C 300 20 375 60 450 40',
    category: 'wave',
  },
  {
    id: 's-curve',
    name: 'S-Curve',
    icon: '\u222B',
    pathData: 'M 0 100 C 100 0 200 200 300 100',
    category: 'wave',
  },
  {
    id: 'circle-top',
    name: 'Circle (Top)',
    icon: '\u25E0',
    pathData: 'M 0 150 A 150 150 0 0 1 300 150',
    category: 'circle',
  },
  {
    id: 'circle-bottom',
    name: 'Circle (Bottom)',
    icon: '\u25E1',
    pathData: 'M 300 0 A 150 150 0 0 1 0 0',
    category: 'circle',
  },
  {
    id: 'circle-full',
    name: 'Full Circle',
    icon: '\u25CB',
    pathData: 'M 150 0 A 150 150 0 1 1 149.99 0',
    category: 'circle',
  },
  {
    id: 'oval-top',
    name: 'Oval (Top)',
    icon: '\u2B2E',
    pathData: 'M 0 80 A 200 80 0 0 1 400 80',
    category: 'circle',
  },
];
